













import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import FileServiceGrid from '@/components/file-service/file-service-grid.vue';

@Component({
  components: {
    PageTitle,
    FileServiceGrid
  }
})
export default class FileServicePage extends Vue {
    // This gets the status of the left sidebar
    private get sidePanelIsOpen() {
        return (this.$root.$children[0].$children[1] as any).menuOpened;    
    }
}
